import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("hamn_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("hamn_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hamn_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("hamn_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerEmployer = async (company_name, name, email, password) => {
    const { data } = await api.post("/employer/register", { company_name, name, email, password });
    localStorage.setItem("hamn_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hamn_token");
    setUser(null);
  };

  const logoutAll = async () => {
    const { data } = await api.post("/auth/logout-all");
    localStorage.setItem("hamn_token", data.token);
    return true;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, registerEmployer, logout, logoutAll }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { formatApiError };
